import {AddPurchaseProxyParams, SignupParams, UpdatePriorityParams} from "features/authentication/types.services";
import {apiService, createApiService} from "features/jwt/apiService";
import {apiErrorFrom} from "features/errors";
import {PurchaseServiceEndpoints} from "features/authentication/services/PurchaseService/config";
import {getCurrentEnv, getCurrentSiteId} from "features/services/utils/env-helper";
import {handleAccountApiResponse} from "features/authentication/helpers";
import {BankIdSession} from "features/authentication/types";
import {createApi} from "features/jwt/api";

export class PurchaseService {

    private static readonly purchaseProxyApi = createApiService(createApi({
        baseURL: window.location.protocol + '//' + window.location.hostname + '/api/signup',
    }));

    public static readonly addPurchase = async (params: SignupParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<void>(PurchaseServiceEndpoints.addPurchase(), {
            ...params,
            siteId: getCurrentSiteId(),
        });

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    };

    public static readonly addPurchaseEidentStart = async (params: SignupParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<string>(PurchaseServiceEndpoints.addPurchaseEidentStart(), {
            ...params,
            environment: getCurrentEnv(),
            returnUrl : window.location.origin + window.location.pathname, // + `?type=${IdentificationFlow.Purchase}`
        });

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return handleAccountApiResponse({ data, error, endpoint, statusCode, method, transportError });
    };

    public static readonly addPurchaseEidentStatus = async (sessionId: string, params: SignupParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<BankIdSession>(PurchaseServiceEndpoints.addPurchaseEidentStatus(), {
            ...params,
            environment: getCurrentEnv(),
            code: sessionId.replaceAll(' ', '+'),
        });

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    };

    public static readonly updatePriority = async (params: UpdatePriorityParams[]) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<void>(PurchaseServiceEndpoints.updatePriority(), params);

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    };

    public static readonly deletePurchase = async (params: SignupParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.delete<void>(PurchaseServiceEndpoints.deletePurchase(params));

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    }

    public static readonly addPurchaseMailProxy = async (params: AddPurchaseProxyParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await PurchaseService.purchaseProxyApi.post<void>(PurchaseServiceEndpoints.addPurchaseMailProxy(), params);

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    }
}
